import { faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import TextInput from '../../../App/Components/Form/TextInput/TextInput'
import { Box } from '../../../Common/Box'
import { IUserHr } from '../../../User/UsersHr/interfaces/IUserHr'

import { PersonEditText } from './style'

type Props = {
  personObject: IUserHr
  setPersonObject: (person: IUserHr) => void
}

const UsersIcon = styled(FontAwesomeIcon)`
  color: #7e7e7e;
  margin-right: 6px;
`

export const FirstNameEditInput: React.FC<Props> = ({
  personObject,
  setPersonObject,
}) => {
  const { t } = useTranslation()

  return (
    <Box mt={2} mb={2}>
      <Box display={'flex'}>
        <UsersIcon icon={faUser} />
        <PersonEditText> {t('First name')}</PersonEditText>
      </Box>
      <TextInput
        value={personObject.firstName}
        onChange={e =>
          setPersonObject({ ...personObject, firstName: e.currentTarget.value })
        }
      />
    </Box>
  )
}
